import { ICON_PATHS, type IconName } from './icons';

export interface IconProps {
  name: IconName;
  /**
   * The kit's render sizes: 22 in rows and widgets, 19 in accent wells, 18 for chevrons and
   * arrows, 17 in icon buttons, 12 for the external-link mark.
   */
  size?: number;
  /** 2 is the active-navigation weight. Everything else stays at 1.5. */
  strokeWidth?: number;
  /** The star is the only icon that fills, and only when a session is saved. */
  filled?: boolean;
  className?: string;
}

export function Icon({ name, size = 22, strokeWidth = 1.5, filled = false, className }: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill={filled ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <path d={ICON_PATHS[name]} />
    </svg>
  );
}
